var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questions_content"},[_c('Q_AVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }